import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ImagesService } from '../../services/utils/images.service';
import { ServicioCuentasMedicasService, CuentaMedicaDomicilioEntity, ParametroSimensEntity, ProfesionalEntity, AdmisionServicioDetalleHonorariosEntity } from '../../services/servicio-cuentas-medicas.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-reporte-cuenta-cobro-domicilio',
  templateUrl: './reporte-cuenta-cobro-domicilio.component.html',
  styleUrls: ['./reporte-cuenta-cobro-domicilio.component.css']
})
export class ReporteCuentaCobroDomicilioComponent implements OnInit {

  loading: boolean;
  error: boolean;

  mensajeError: string;
  logo: string;

  fechaImpresion: Date;

  admisiones: AdmisionServicioDetalleHonorariosEntity[] = [];
  objectCuentaMedica: CuentaMedicaDomicilioEntity = {};
  parametroSimens: ParametroSimensEntity = {};
  profesional: ProfesionalEntity = {};

  constructor( private activatedRoute: ActivatedRoute,
               private servicioImagenes: ImagesService,
               private servicioCuentaMedica: ServicioCuentasMedicasService
              ) {
    this.activatedRoute.params.subscribe(params => {
      this.objectCuentaMedica.codigo = params['codigoBaseDatos'];
      this.objectCuentaMedica.sede = Number(params['uncoSede']);
      this.objectCuentaMedica.uncoLogin = Number(params['uncoLogin']);
      this.objectCuentaMedica.uncoProfesional = Number(params['profesional']);
      this.objectCuentaMedica.uncoProfesionalRango = Number(params['uncoRango']);
    });
  }

  ngOnInit() {
    this.onGenerate();
  }

  onGenerate() {
    this.loading = true;
    this.fechaImpresion = new Date();
    this.getLogo(this.objectCuentaMedica.codigo);
  }

  onFiltrosCompletados() {
    this.onGenerate();
  }

  async getLogo(codigoBaseDatos: string) {
    try {
      this.logo = '';
      const request = await this.servicioImagenes.getLogo(codigoBaseDatos);
      request.subscribe((data: any) => {
        this.logo = data.source;
        this.getParametroSimens();
      }, (err: HttpErrorResponse) => {
        this.loading = false;
        this.logo = '';
        this.error = true;
        this.mensajeError = 'Error al intentar obtener el logo de la entidad, verifique conexión a internet o reporte caso al administrador.';
        console.error('Reporte-Cuenta-Cobro-Domicilio.getLogo()', err);
      })
    } catch(e) {
      this.loading = false;
      this.logo = '';
      this.error = true;
      this.mensajeError = 'Error grave al intentar obtener logo de la entidad, reporte el caso al administrador.';
      console.error('Reporte-Cuenta-Cobro-Domicilio.getLogo()', e);
    }
  }

  async getParametroSimens() {
    try {
      const request = await this.servicioCuentaMedica.getParametroSimensDomicilio(this.objectCuentaMedica);
      request.subscribe((data: ParametroSimensEntity) => {
        this.parametroSimens = data;
        this.getProfesional();
      }, (err: HttpErrorResponse) => {
        this.loading = false;
        this.parametroSimens = null;
        this.error = true;
        this.mensajeError = 'Error al intentar obtener información de la entidad, verifique conexión a internet o reporte el caso al administrador.';
        console.error('Reporte-Cuenta-Cobro-Domicilio.getParametroSimens()', err);
      })
    } catch(e) {
      this.loading = false;
      this.parametroSimens = null;
      this.error = true;
      this.mensajeError = 'Error grave al intentar obtener información de la entidad, reporte el caso al administrador.';
      console.error('Reporte-Cuenta-Cobro-Domicilio.getParametroSimens()', e);
    }
  }

  async getProfesional() {
    try {
      const request = await this.servicioCuentaMedica.getProfesionalDomicilio(this.objectCuentaMedica);
      request.subscribe((data: ProfesionalEntity) => {
        this.profesional = data;
        this.getAdmisiones();
      }, (err: HttpErrorResponse) => {
        this.loading = false;
        this.profesional = null;
        this.error = true;
        this.mensajeError = 'Error al intentar obtener información del profesional, verifique conexión a internet o reporte caso al administrador.';
        console.error('Reporte-Cuenta-Cobro-Domicilio.getProfesional()', err);
      })
    } catch(e) {
      this.loading = false;
      this.profesional = null;
      this.error = true;
      this.mensajeError = 'Error grave al intentar obtener información del profesional, reporte caso al administrador.';
      console.error('Reporte-Cuenta-Cobro-Domicilio.getProfesional()', e);
    }
  }

  async getAdmisiones() {
    try{ 
      const request = await this.servicioCuentaMedica.getAdmisionesDomicilio(this.objectCuentaMedica);
      if(request) {
        request.subscribe((data: AdmisionServicioDetalleHonorariosEntity[]) => {
          this.admisiones = data.sort((a: AdmisionServicioDetalleHonorariosEntity, b: AdmisionServicioDetalleHonorariosEntity) => {
            const consecutivoA = this.getConsecutivoComparacion(a);
            const consecutivoB = this.getConsecutivoComparacion(b);
            if (consecutivoA > consecutivoB) return 1;
            if (consecutivoB > consecutivoA) return -1;
            return 0;
          });
          this.loading = false;
        }, (err: HttpErrorResponse) => {
          this.loading = false;
          this.admisiones = null;
          this.error = true;
          this.mensajeError = 'Error al intentar obtener información de las admisiones, verifique conexión a internet o reporte caso al administrador.';
          console.error('Reporte-Cuenta-Cobro-Domicilio.getAdmisiones()', err);
        });
      } else {
        this.loading = false;
        this.admisiones = null;
        this.error = true;
        this.mensajeError = 'Error al intentar obtener información de las admisiones, verifique conexión a internet o reporte caso al administrador.';
        console.error('Reporte-Cuenta-Cobro-Domicilio.getAdmisiones() : Request nula');
      }
    } catch(e) {
      this.loading = false;
      this.admisiones = null;
      this.error = true;
      this.mensajeError = 'Error grave al intentar obtener información de las admisiones, reporte caso al administrador.';
      console.error('Reporte-Cuenta-Cobro-Domicilio.getAdmisiones()', e);
    }
  }

  // Auxiliar

  isDescuento(a: AdmisionServicioDetalleHonorariosEntity) {
    return !a.admisionServicioDetalle.admisionEmpresaPuntoAtencion.admisionEmpresa.admision.consecutivo || a.admisionServicioDetalle.admisionEmpresaPuntoAtencion.admisionEmpresa.admision.consecutivo <= 0;
  }

  getEmpresa(a: AdmisionServicioDetalleHonorariosEntity) {
    return a.admisionServicioDetalle.admisionEmpresaPuntoAtencion.admisionEmpresa.empresa.descripcionCorta;
  }

  getIdentificacion(a: AdmisionServicioDetalleHonorariosEntity) {
    const tipo = a.admisionServicioDetalle.admisionEmpresaPuntoAtencion.admisionEmpresa.admision.afiliado.tipoDocumento;
    const numero = a.admisionServicioDetalle.admisionEmpresaPuntoAtencion.admisionEmpresa.admision.afiliado.numeroIdentificacion;
    return tipo && numero ? `${tipo} - ${numero}` : '';
  }

  getNombrePaciente(a: AdmisionServicioDetalleHonorariosEntity){
    const primerNombre = a.admisionServicioDetalle.admisionEmpresaPuntoAtencion.admisionEmpresa.admision.afiliado.primerNombre;
    const segundoNombre = a.admisionServicioDetalle.admisionEmpresaPuntoAtencion.admisionEmpresa.admision.afiliado.segundoNombre;
    const primerApellido = a.admisionServicioDetalle.admisionEmpresaPuntoAtencion.admisionEmpresa.admision.afiliado.primerApellido;
    const segundoApellido = a.admisionServicioDetalle.admisionEmpresaPuntoAtencion.admisionEmpresa.admision.afiliado.segundoApellido;
    return `${primerNombre}${segundoNombre ? ' ' + segundoNombre : ''}${' ' + primerApellido}${segundoApellido ? ' ' +segundoApellido : ''}`;
  }

  getAdmision(a: AdmisionServicioDetalleHonorariosEntity) {
    const prefijo = a.admisionServicioDetalle.admisionEmpresaPuntoAtencion.admisionEmpresa.admision.prefijo;
    const consecutivo = a.admisionServicioDetalle.admisionEmpresaPuntoAtencion.admisionEmpresa.admision.consecutivo;
    return consecutivo && consecutivo > 0 ? `${prefijo} - ${consecutivo}` : '';
  }

  getCantidad(a: AdmisionServicioDetalleHonorariosEntity) {
    const isDescuento = this.isDescuento(a);
    return isDescuento ? '' : a.cantidadRealizada;
  }

  getSubtotal(a: AdmisionServicioDetalleHonorariosEntity): number {
    return a.cantidadRealizada * a.tarifaRealizada;
  }

  getTotal() {
    let total = 0;
    if (this.admisiones && this.admisiones.length > 0) {
      this.admisiones.forEach((d: AdmisionServicioDetalleHonorariosEntity) => {
        const subtotal = d.cantidadRealizada * d.tarifaRealizada;
        total += subtotal;
      })
    }
    return total;
  }

  isNota() {
    return this.parametroSimens && this.parametroSimens.notaImpresionCuentaCobroDomiciliario && this.parametroSimens.notaImpresionCuentaCobroDomiciliario.length > 0;
  }

  getConsecutivoComparacion(a: AdmisionServicioDetalleHonorariosEntity) {
    const consecutivo = a.admisionServicioDetalle.admisionEmpresaPuntoAtencion.admisionEmpresa.admision.consecutivo;
    return consecutivo > 0 ? consecutivo : 999999999;
  }

}
